import moment from "moment"

const Event_Description = cell => {
  return cell.value ? cell.value : ""
}
const Vendor_name = cell => {
  return cell.value
    ? cell.value
    : "all vendors of " + cell.row.original.ceremony_name
}
const Package = cell => {
  return cell.value
    ? cell?.row?.original?.is_canceled === 1
      ? moment(cell.value).format("yyyy-MM-DD HH:mm") + " (Canceled)"
      : cell?.row?.original?.is_deleted === 1
      ? moment(cell.value).format("yyyy-MM-DD HH:mm") + " (Deleted)"
      : moment(cell.value).format("yyyy-MM-DD HH:mm")
    : ""
}
const PurchaseDate = cell => {
  return cell.value ? moment(cell.value).format("yyyy-MM-DD HH:mm") : ""
}
const PurchaseAmount = cell => {
  return cell.value ? cell.value : ""
}
const PaidDate = cell => {
  return cell.value ? moment(cell.value).format("yyyy-MM-DD HH:mm") : ""
}

export {
  Event_Description,
  Package,
  PurchaseDate,
  PaidDate,
  PurchaseAmount,
  Vendor_name,
}
